import React, { useState } from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import { BarLoader } from "react-spinners";
import { useAppDispatch } from "../app/store";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { resetPassword } from "../features/authSlice";
import { toast } from "react-toastify";

const PasswordReset = () => {
  const [password, setPassword] = useState<string>("");
  const [password_confirmation, setConfirmPassword] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();

  const { token = "" } = useParams<{
    token?: string;
  }>();
  const email = searchParams.get("email") || "";

  const navigate = useNavigate();

  // Your component code here
  const togglePassword = () => {
    const password = document.getElementById("password") as HTMLInputElement;
    const eyes = document.getElementById("togglePassword");

    if (password.type === "password") {
      password.type = "text";
      if (eyes) {
        eyes.className = "bi bi-eye";
      }
    } else {
      password.type = "password";
      if (eyes) {
        eyes.className = "bi bi-eye-slash";
      }
    }
  };

  const toggleConfirmPassword = () => {
    const password = document.getElementById(
      "password_confirmation"
    ) as HTMLInputElement;
    const eyes = document.getElementById("toggleConfirmPassword");

    if (password.type === "password") {
      password.type = "text";
      if (eyes) {
        eyes.className = "bi bi-eye";
      }
    } else {
      password.type = "password";
      if (eyes) {
        eyes.className = "bi bi-eye-slash";
      }
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    let data = {
      token: token,
      email: email,
      password: password,
      password_confirmation: password_confirmation,
    };
    e.preventDefault();
    setLoading(true);
    dispatch(resetPassword(data))
      .unwrap()
      .then(() => {
        setLoading(false);
        navigate("/login");
        toast.success("Password reset successful login with your new password");
      })
      .catch((error) => {
        setLoading(false);
        setPassword("");
        setConfirmPassword("");
        toast.error(error);
      });

    // Handle form submission here
  };

  return (
    <div>
      <Container>
        <Row>
          <Col sm={12} md={12}>
            <div
              className="d-flex align-items-center justify-content-center"
              style={{ marginTop: "10%" }}
            >
              <div className="card w-50 shadow-lg p-3 mb-5 bg-body-tertiary rounded border-0">
                <div className="card-body py-5">
                  <div className="d-flex justify-content-center mb-3">
                    <Image
                      src="/images/logo.png"
                      className="img-fluid"
                      alt="images"
                    />
                  </div>
                  <h3 className="text-center fw-bold">Reset Password </h3>

                  <div className="form-group">
                    <label className="form-label">Password</label>
                    <div className="input-group">
                      <input
                        type="password"
                        className="form-control p-3 rounded-0"
                        placeholder="password"
                        name="password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      <span className="input-group-text">
                        <i
                          className="bi bi-eye-slash"
                          id="togglePassword"
                          onClick={togglePassword}
                        ></i>
                      </span>
                    </div>
                  </div>

                  <div className="form-group mt-3">
                    <label className="form-label">Confirm Password</label>
                    <div className="input-group">
                      <input
                        type="password"
                        className="form-control p-3 rounded-0"
                        placeholder="confirm password"
                        name="password_confirmation"
                        id="password_confirmation"
                        value={password_confirmation}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                      <span className="input-group-text">
                        <i
                          className="bi bi-eye-slash"
                          id="toggleConfirmPassword"
                          onClick={toggleConfirmPassword}
                        ></i>
                      </span>
                    </div>
                  </div>

                  <div className="form-group mt-3">
                    {loading && loading ? (
                      <BarLoader
                        color="#073367"
                        loading={loading}
                        width={150}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                      />
                    ) : (
                      <button
                        className="btn btn-primary w-100 p-3"
                        onClick={handleSubmit}
                      >
                        <h4>Login</h4>
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PasswordReset;
